<script>
  import { _ as t } from 'svelte-i18n';
  import './i18n';

  import SearchResults from './components/SearchResults.svelte'

  const INPUT_REQUEST_DELAY = 500;

  const currentInputDelay = 0;
  let inputTimerId = null;

  let models = []
  let vendors = []
  let isSearching = false;
  let noSearchResults = false;
  let showModelsFirst = false;

  let searchInput;

  const closeSearch = () => {
    isSearching = false;
    models = [];
    vendors = [];
    searchInput.value = '';
  }

  const searchRequest = async (data) => {
    const res = await fetch(`/catalog-search?query=${data}`).then(r => r.json());
    models = res.models;
    vendors = res.vendors;
    showModelsFirst = res.show_models_first
    noSearchResults = !(models.length || vendors.length)
  };

  const handleSearchInput = (evt) => {
    const inputData = evt.target.value;
    clearTimeout(inputTimerId);
    if (inputData) {
      isSearching = true;
      inputTimerId = setTimeout(() => searchRequest(inputData), INPUT_REQUEST_DELAY);
    } else {
      closeSearch();
    }
  }

  const handleWindowKeydown = (evt) => {
    if (evt.key === 'Escape') {
      closeSearch();
    }
  }
</script>

<svelte:window on:keydown={handleWindowKeydown} />

<div class="mb-4">
  <div class="search form-group mb-2 mt-4">
    <h3 class="h5 mb-3">{$t('search.header')}</h3>
    <div class="search__input-container">
      <div class="input-group input-group-lg">
        <input 
          bind:this={searchInput}
          on:input={handleSearchInput} 
          type="text" 
          value="" 
          placeholder="{$t('search.placeholder')}" 
          class="form-control search__input {isSearching ? 'active' : ''}"
        >  
      </div>
      <i 
        on:click={closeSearch}
        class="{isSearching ? '' : 'd-none'} search__close-icon bi bi-x"
      ></i>
    </div>
    {#if isSearching}
      <div class="results">
        {#if !vendors.length && !models.length}
          <div class="text-secondary">
            {noSearchResults ? $t('search.notFound') : $t('search.search')}
          </div>
        {/if}

        {#if vendors.length && models.length && showModelsFirst}
          <SearchResults title={$t('search.models')} results={models} type="model" />
          <SearchResults title="Марки" results={vendors} type="vendor" />
        {:else}
          {#if vendors.length}
            <SearchResults title="Марки" results={vendors} type="vendor" />
          {/if}
          {#if models.length}
            <SearchResults title={$t('search.models')} results={models} type="model" />
          {/if}
        {/if}

        <div class="results__white-line"></div>
      </div>
    {/if}   
  </div>
</div>

{#if isSearching}
  <div on:click={closeSearch} class="backdrop"></div>
{/if}

<style lang="scss">
  .backdrop {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,0.5);
    top: 0;
    left: 0;
    z-index: 3;
  }

  .search {
    position: relative;
    z-index: 10;

    &__input.active {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border: 1px solid #86b7fe;
      outline: 0;
      box-shadow: 0 0 0 .25rem rgba(13,110,253,.25);
    }

    &__input-container {
      position: relative;
    }

    &__close-icon {
      color: grey;
      font-size: 28px;
      position: absolute;
      top: 3px;
      right: 10px;
      z-index: 10;
      cursor: pointer;
    }
  }

  .results {
    background: white;
    color: black;
    z-index: 10;
    position: absolute;
    top: 88px;
    width: 100%;
    font-size: 1.1rem;
    padding: 15px;
    padding-bottom: 7px;
    border-bottom-left-radius: .5rem;
    border-bottom-right-radius: .5rem;
    border: 1px solid #86b7fe;
    outline: 0;
    box-shadow: 0 8px 0 .25rem rgba(13,110,253,.25);

    &:before {
      background-color: white;
      height: 4px;
      content: "";
      position: absolute;
      width: 100%;
      top: -5px;
      left: 0;
      right: 0;
    }

    &:after {
      background-color: white;
      height: 15px;
      content: "";
      position: absolute;
      width: 100%;
      bottom: -8px;
      left: 0;
      right: 0;
      outline: 1px solid #86b7fe;
      border-bottom-left-radius: .5rem;
      border-bottom-right-radius: .5rem;
    }

    &__white-line {
      background-color: white;
      height: 5px;
      content: "";
      position: absolute;
      width: 100%;
      bottom: 5px;
      left: 0;
      right: 0;
      z-index: 10;
    }
  }
</style>